import React from 'react';
import { QuestionPassStateId } from '../../../learnware/LearnwareEnums';
import { QuestionPassState } from '../QuestionPassState';
export class QuestionPassState_Passed2 extends QuestionPassState {
    id = QuestionPassStateId.Passed2;
    name = (React.createElement("span", null,
        React.createElement("i", { className: "fas fa-trophy" }),
        " K\u00F6nigsklasse - 2 Mal richtig"));
    color = 'success';
    orderInProgressbar = 2;
    isDefaultFiltered = true;
}
